import { createSlice } from "@reduxjs/toolkit";
//import { sendEmailAction } from "./actions";

interface EmailState {
  isLoading: boolean;
  isError: boolean;
  isLoggedIn: boolean;
  message?: string
}
const initialState: EmailState = {
  isLoading: false,
  isError: false,
  isLoggedIn: false,
  message: ""
};

const fallbackErrorMessage = "Something went wrong. Please try again."

export const EmailSlice = createSlice({
  name: "emailSlice",
  initialState,
  reducers: {
    resetEmailList: () => initialState,
  },
  // extraReducers: (builder) => {
  //   builder.addCase(sendEmailAction.pending, (state: any) => {
  //     state.isLoading = true;
  //     state.isError = false;
  //     state.message = ""
  //   });
  //   builder.addCase(sendEmailAction.fulfilled, (state: any, action) => {
  //     state.isLoading = false;
  //     state.isError = false;
  //     state.message  = action?.payload?.message
  //   });
  //   builder.addCase(sendEmailAction.rejected, (state: any, action) => {
  //     state.isLoading = false;
  //     state.isError = true;
  //     state.errorMessage = action?.payload ?? fallbackErrorMessage;

  //   });
  // },
  //commenting for future use
});



export const {
  resetEmailList
} = EmailSlice.actions;

export const emailSliceReducer = EmailSlice.reducer;
